const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.764706%,14.509805%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 22.351562 23.945312 C 21.929688 23.945312 21.507812 23.78125 21.1875 23.460938 L 6.273438 8.550781 C 5.628906 7.90625 5.628906 6.863281 6.273438 6.21875 C 6.917969 5.574219 7.960938 5.574219 8.605469 6.21875 L 23.515625 21.128906 C 24.160156 21.773438 24.160156 22.816406 23.515625 23.460938 C 23.195312 23.78125 22.773438 23.945312 22.351562 23.945312 Z M 22.351562 23.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20%,24.313726%,28.235295%)",
      fillOpacity: 1
    },
    d: "M 13.824219 15.417969 C 13.402344 15.417969 12.980469 15.257812 12.660156 14.933594 L 6.273438 8.550781 C 5.628906 7.90625 5.628906 6.863281 6.273438 6.21875 C 6.917969 5.574219 7.960938 5.574219 8.605469 6.21875 L 14.992188 12.605469 C 15.636719 13.246094 15.636719 14.292969 14.992188 14.933594 C 14.667969 15.257812 14.246094 15.417969 13.824219 15.417969 Z M 13.824219 15.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,78.431374%,26.274511%)",
      fillOpacity: 1
    },
    d: "M 7.441406 12.898438 L 4.855469 14.710938 L 4.039062 11.664062 L 0.898438 11.390625 L 2.230469 8.53125 L 0 6.300781 L 2.859375 4.96875 L 2.582031 1.824219 L 5.632812 2.640625 L 7.441406 0.0546875 L 9.25 2.640625 L 12.296875 1.824219 L 12.019531 4.96875 L 14.878906 6.300781 L 12.648438 8.53125 L 13.984375 11.390625 L 10.839844 11.664062 L 10.023438 14.710938 Z M 7.441406 12.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,87.843138%,60.784316%)",
      fillOpacity: 1
    },
    d: "M 7.441406 10.664062 L 5.949219 11.707031 L 5.480469 9.949219 L 3.664062 9.792969 L 4.433594 8.140625 L 3.148438 6.855469 L 4.796875 6.085938 L 4.636719 4.273438 L 6.394531 4.742188 L 7.441406 3.25 L 8.484375 4.742188 L 10.242188 4.273438 L 10.082031 6.085938 L 11.734375 6.855469 L 10.445312 8.140625 L 11.214844 9.792969 L 9.402344 9.949219 L 8.929688 11.707031 Z M 7.441406 10.664062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.76ffb0c2eff97b8f59142d4bb2efe876.svg";
export { ForwardRef as ReactComponent };